var menu = $(".header");
var sideBar = $('.sideBar');
var offset = 120;
var x = document.getElementById("navigation");
var $window = $(window);



$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();



    return elementBottom > viewportTop && elementTop < viewportBottom;
};





$(window).load(function () {
    // executes when complete page is fully loaded, including all frames, objects and images

    $(".preLoader").delay(4000).addClass("close");



    //

});


$(".quote_one").scroll(function () {
    if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
        alert('working')
    } else {
        $("span").hide();
    }
});



$(window).on('resize scroll', function () {




    var windowTop = $(window).scrollTop();
    var quote_one = $('.quote_one').offset().top;
    var quote_two = $('.quote_two').offset().top;



    if (windowTop > quote_one) {
        TweenLite.to($(".bg_three"), 1.15, { opacity: 0, ease: Expo.easeOut });
        TweenLite.to($(".aboutCon"), 1.15, { opacity: 1, ease: Expo.easeOut });

    } else {
        TweenLite.to($(".bg_three"), 0.15, { opacity: 1, ease: Expo.easeOut });
    }
    if (windowTop > quote_two) {
        TweenLite.to($(".bg_two"), 0.15, { opacity: 0, ease: Expo.easeOut });
    } else {
        TweenLite.to($(".bg_two"), 0.15, { opacity: 1, ease: Expo.easeOut });
    }









    $('.transitionIn').each(function () {
        var activeColor = $(this).attr('id');
        if ($(this).isInViewport()) {

            TweenLite.to(this, 2.5, { opacity: 1, delay: 0.5, ease: Power1.easeOut });

        } else {

            TweenLite.to(this, 0, { opacity: 0, delay: 0, ease: Power1.easeOut });



        }
    });
    $('.image').each(function () {
        var activeColor = $(this).attr('id');
        if ($(this).isInViewport()) {

            TweenLite.to(this, 1.5, { opacity: 1, delay: 0.5, ease: Power1.easeOut });



        } else {

            TweenLite.to(this, 0, { opacity: 0, delay: 0.5, ease: Power1.easeOut });
            return; //break the loop



        }
    });


});


function showMenu() {
    if (x.className === "menu") {
        x.className += " responsive";
        sideBar.addClass('responsive');


    } else {
        x.className = "menu";
        sideBar.removeClass('responsive');
        $("body").css({
            "overflow": "scroll",
            "position": "relative"
        });
    }
}



//smoothscroll
$('a[href^="#"]').on('click', function (e) {

    $(".menu").removeClass("responsive");
    sideBar.removeClass('responsive');
    $("body").css({
        "overflow": "scroll",
        "position": "relative"
    });
    e.preventDefault();
    var target = this.hash,
        $target = $(target);

    TweenLite.to(window, 1, {
        scrollTo: {
            ease: Expo.easeOut,
            y: $target.offset().top
        },
        onComplete: function () {
            window.location.hash = target;
        }
    });







});




/* Page Scroll to id fn call */
$("a[rel='gotoSection']").mPageScroll2id({
    highlightSelector: "#navigation-menu a",
    clickEvents: false


});

/* jquery.address fn */
$.address.change(function (event) {
    var hash = event.value.split("/")[1] || "#top";
    $.mPageScroll2id("scrollTo", hash, {
        clicked: $("a[href='" + hash + "']")
    });
});

$("a[rel='gotoSection']").click(function (e) {
    e.preventDefault();


    var href = $(this).attr("href");
    if ($.address.value() === "/" + href) {
        $.address.history(false);
        $.address.value("#");



    } else {
        $.address.history(true);
    }
    $.address.value($(this).attr("href"));

});

